import gtm from '@/utils/gtm';
import { createPortal } from 'react-dom';
import EcoIconClose from 'eco-design-micro/icons/eco-icon-close';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { isMembersFestival } from '@/utils/membersFestival';
import './index.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';
import LoginFormModal from '@/components/LoginFormModal';
import { useLang } from './useLang';
// 没有登录
export default function HeaderUserTipsContent({ closeCallback }: { closeCallback?: any }) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang();
    const [registerUrl, setRegisterUrl] = useState('');
    // const [registerUrl1, setRegisterUrl1] = useState('');
    const [loginUrl, setLoginUrl] = useState('');
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const mfStatus = isMembersFestival(locale);

    useEffect(() => {
        setRegisterUrl(`${window.location.origin}/${locale}/register?redirect=${encodeURIComponent(window.location.href)}`);
        // setRegisterUrl1(`${window.location.origin}/${locale}/register/passwordless?redirect=${encodeURIComponent(window.location.href)}`);
        setLoginUrl(`${window.location.origin}/${locale}/login?redirect=${encodeURIComponent(window.location.href)}`);
    }, []);
    const textButton = t('button');
    const textButton1 = t('button1');
    const textTips1 = t('register_tip');
    const textLogin = t('login');
    const closeHandle = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_close',
            button_name: 'Close',
            type: 'Authentication',
        });
        if (closeCallback) {
            closeCallback();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className="HeaderV2-UserTipsWin-content">
            <div className="HeaderV2-UserTipsWin-line1">
                <TipsIconA />
                {mfStatus === 0 ? t('desc_1') : t('desc')}
            </div>
            <EcoLink
                className="HeaderV2-UserTipsWin-line2"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'authentication_button',
                    type: 'Modal',
                    button_name: textButton1,
                    url: 'none',
                }}
                // href={registerUrl1}
                onClick={(event) => {
                    event.stopPropagation();
                    signupCookie?.({
                        entry_name: 'top floating_Password-free Register',
                        page_url: window.location.href,
                    });
                    closeCallback && closeCallback();
                    setShowLoginModal(true);
                }}
            >
                {textButton1}
            </EcoLink>
            <EcoLink
                className="HeaderV2-UserTipsWin-line4"
                href={registerUrl}
                onClick={() => signupCookie?.({ entry_name: 'top floating' })}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'signup_start',
                    entry_type: 'fixed entry',
                    entry_name: 'top floating',
                    entry_position: 'none',
                    source_channel: 'Website',
                }}
            >
                {textButton}
            </EcoLink>
            <div className="HeaderV2-UserTipsWin-line3">
                {textTips1}
                <EcoLink
                    className="HeaderV2-UserTipsWin-line3-link"
                    href={loginUrl}
                    onClick={() => signupCookie?.({ entry_name: 'top floating' })}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'signup_start',
                        entry_type: 'fixed entry',
                        entry_name: 'top floating',
                        entry_position: 'none',
                        source_channel: 'Website',
                    }}
                >
                    {textLogin}
                </EcoLink>
            </div>
            <EcoIconClose className="HeaderV2-UserTipsWin-close" onClick={closeHandle} />
            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </div>
    );
}

const TipsIconA = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.66666 8.00016L5.99999 11.3335L13.3333 4.3335" stroke="#30BF00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    );
};
